import type { ContactUsRequest } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPublicApi } from '../../services/api';

export function useContactUs(options?: UseMutationOptions<void, unknown, ContactUsRequest>) {
  return useMutation({
    mutationFn: async (contactUsRequest) => {
      const api = getPublicApi();

      await api.contactUs({ contactUsRequest });
    },
    ...options,
  });
}
